import React, { type FC } from "react";
import { Link } from "react-router-dom";
import { AvacusLogo } from "~/src/assets/img";

const AvacusLogoLink: FC<{ to?: string }> = ({ to = "/login" }) => (
  <Link to={to}>
    <img
      src={AvacusLogo}
      alt="avacus-logo"
      className="h-8 w-auto object-contain"
    />
  </Link>
);

export default AvacusLogoLink;
